import { Navigate, Route, Routes } from 'react-router-dom';

import { PigeonLoans } from './PigeonLoans';
import { Success } from './Success';

export const PigeonLoansRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<PigeonLoans />} />
      <Route path="success" element={<Success />} />

      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};
